import { render, staticRenderFns } from "./CoproducerProductCard.vue?vue&type=template&id=4155729a&scoped=true&"
import script from "./CoproducerProductCard.vue?vue&type=script&lang=js&"
export * from "./CoproducerProductCard.vue?vue&type=script&lang=js&"
import style0 from "./CoproducerProductCard.vue?vue&type=style&index=0&id=4155729a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4155729a",
  null
  
)

export default component.exports